import React from 'react';
// import share from "../../assets/images/Vector (6).png";
// import duplicate from "../../assets/images/Edit.png";
// import deleteBtn  from "../../assets/images/Vector (7).png";
import "./modal.css"

export default function Modal({active, setActive,children}) {
  return (
      <div className={active ? "modal_active" : "modal" } onClick={()=>setActive(false)}>
      <div className="modal_content" onClick={e => e.stopPropagation()}>
        {children}
              {/* <div className='modal_detail'>
                  <div className="modal-icon">
                  <img  src={share} alt="share" /> 
                  </div>
                  <p style={{margin: "5px"}}>Share trip</p>
              </div>
              <div className='modal_detail'>
                    <div className="modal-icon">
                      <img src={duplicate} alt="duplicate" />
                      </div>
                    <p style={{margin: "5px"}}>Duplicate trip</p>
              </div>
              <div className='modal_detail'>
                  <div className="modal-icon">
                      <img src={deleteBtn} alt="delete" />
                   </div>
          <p style={{ margin: "5px", color:"red"}}>Delete trip</p>
              </div> */}
          </div>
    </div>
  )
}
